import { http } from '../api/http';

export type AdminPermission = {
  id: number;
  code: string;
  label: string;
  description?: string | null;
  group?: string | null;
  is_active: boolean;
};

export type AdminRole = {
  id: number;
  code: string;
  label: string;
  is_active: boolean;
  permissions: string[];
  userCount?: number;
};

export const AdminRolesService = {
  listRoles() {
    return http<{ ok: boolean; data: AdminRole[] }>('/admin/roles');
  },

  getRole(id: number | string) {
    return http<{ ok: boolean; data: AdminRole }>(`/admin/roles/${id}`);
  },

  createRole(payload: { code: string; label: string; is_active?: boolean; permissionCodes?: string[] }) {
    return http<{ ok: boolean; data: AdminRole }>('/admin/roles', {
      method: 'POST',
      body: payload
    });
  },

  updateRole(id: number | string, payload: { label?: string; is_active?: boolean }) {
    return http<{ ok: boolean; data: AdminRole }>(`/admin/roles/${id}`, {
      method: 'PUT',
      body: payload
    });
  },

  updateRolePermissions(id: number | string, permissionCodes: string[]) {
    return http<{ ok: boolean; data: AdminRole }>(`/admin/roles/${id}/permissions`, {
      method: 'PUT',
      body: { permissionCodes }
    });
  },

  listPermissions() {
    return http<{ ok: boolean; data: AdminPermission[] }>('/admin/permissions');
  }
};
